<template>
  <div id="avaliacao-atendimentos">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Avaliação do atendimento"
            description="A avaliação dos atendimentos pelo cidadão"
            url="/vinculo-acompanhamento"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-3511"
            pageIdentifier="avaliacao-atendimentos"
          />
        </div>
        <div class="col-lg-12">
          <iframe
            src="https://www.youtube.com/embed/zrcsL47YZ10"
            width="100%"
            height="400"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <p>A avaliação dos atendimentos pelo cidadão:</p>
          <ul>
            <li>
              Contribui para pontuação extra à equipe, independente da nota do
              usuário ao atendimento; e
            </li>

            <li>
              Pode ser ensinada ao cidadão pelos ACS na visita e demais
              profissionais da eSF, eAP, eSB e eMulti, no atendimento;
            </li>

            <li>
              É necessário ensinar aos cidadãos atendidos como é que baixa o
              aplicativo Meu SUS Digital e avalia o atendimento.
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import utils from '@/mixins/utils.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

export default {
  name: 'AvaliacaoAtendimentos',
  components: {
    Menu,
    Footer,
    SectionTitle,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [utils],
  metaInfo: {
    title: 'Avaliação do atendimento',
    titleTemplate: null,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style scoped lang="scss">
#avaliacao-atendimentos ul {
  list-style-type: disc;
  margin: 10px 40px;
  li {
    margin-bottom: 10px;
  }
}
</style>
